import { Box, styled, Typography, useMediaQuery } from '@mui/material';
import React, { memo } from 'react';
import HotSpotIcon from '../../assets/icon/hot-spot-icon';
import { Switch } from '..';

const HotSpotButtonStyle = styled(Box)<any>(({ theme }) => ({
  zIndex: 1,
  alignItems: 'center',
  background: theme.palette.primary.contrastText,
  borderRadius: theme.spacing(1),
  display: 'flex',
  width: '10.875rem',
  height: '2.938rem',
  [theme.breakpoints.down('lg')]: {
    height: '1.8rem',
    width: '6.2rem',
    gap: 3,
    justifyContent: 'center',
  },
  justifyContent: 'space-evenly',
  cursor: 'pointer',
}));

type PropTypes = {
  checked: boolean;
  onChange: () => void;
};

function CustomHotspotButton({ checked, onChange }: PropTypes) {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  return (
    <HotSpotButtonStyle onClick={onChange}>
      {isMobile ? null : (
        <HotSpotIcon
          style={{
            fontSize: 'small',
            marginLeft: 1,
          }}
        />
      )}
      <Typography
        color={'white'}
        sx={{ fontSize: { xs: '.7rem', lg: '1rem' }, userSelect: 'none' }}
      >
        Hotspot
      </Typography>
      <Switch checked={checked} />
    </HotSpotButtonStyle>
  );
}

export default memo(CustomHotspotButton);
